;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();export const ANALYTICS_OPT_OUT_COOKIE = 'nt_analytics_opt_out';

const INTERNAL_EMAIL_DOMAINS = ['nteams.com'];
const ANALYTICS_OPT_OUT_MAX_AGE_SECONDS = 365 * 24 * 60 * 60;

export function isInternalEmail(email: string | null | undefined): boolean {
  if (!email) return false;

  const normalizedDomain = email.trim().toLowerCase().split('@').at(-1);
  if (!normalizedDomain) return false;

  return INTERNAL_EMAIL_DOMAINS.includes(normalizedDomain);
}

export function isAnalyticsOptedOut(cookieString: string | null | undefined): boolean {
  if (!cookieString) return false;

  return cookieString
    .split(';')
    .some((cookie) => cookie.trim() === `${ANALYTICS_OPT_OUT_COOKIE}=1`);
}

export function optOutAnalyticsInBrowser(): void {
  if (typeof document === 'undefined') return;

  document.cookie = `${ANALYTICS_OPT_OUT_COOKIE}=1; ${getAnalyticsCookieAttributes()}`;

  if (typeof window === 'undefined') return;

  void import('posthog-js')
    .then(({ default: posthog }) => posthog.opt_out_capturing())
    .catch(() => {});
}

export async function optInAnalyticsInBrowser(): Promise<void> {
  if (typeof document === 'undefined') return;

  document.cookie = `${ANALYTICS_OPT_OUT_COOKIE}=0; ${getAnalyticsCookieAttributes()}`;

  if (typeof window === 'undefined') return;

  try {
    const { default: posthog } = await import('posthog-js');
    posthog.opt_in_capturing();
  } catch {}
}

function getAnalyticsCookieAttributes(): string {
  return [
    'Path=/',
    `Max-Age=${ANALYTICS_OPT_OUT_MAX_AGE_SECONDS}`,
    'SameSite=Lax',
    getAnalyticsCookieDomainAttribute(),
    getAnalyticsCookieSecureAttribute(),
  ]
    .filter(Boolean)
    .join('; ');
}

function getAnalyticsCookieDomainAttribute(): string {
  if (typeof window === 'undefined') return '';

  const hostname = window.location.hostname.toLowerCase();
  if (hostname === 'nativeteams.com' || hostname.endsWith('.nativeteams.com')) {
    return 'Domain=.nativeteams.com';
  }

  return '';
}

function getAnalyticsCookieSecureAttribute(): string {
  if (typeof window === 'undefined' || window.location.protocol !== 'https:') return '';

  return 'Secure';
}
